





















import Vue from 'vue';
import { MASS } from '@/mass/models/Mass';
import massClient from '../../apis';

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    admin: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      MASS,
      showUpdateSuperAdminBox: false,
    };
  },
  methods: {
    confirmUpdate() {
      massClient.sendReplaceSuperUserTpl({
        openid: this.admin.openid,
      }).success((r) => {
        if (r.code === 0) {
          this.$Message.success('发送成功，请等待审核');
          this.$emit('confirm');
        }
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.showUpdateSuperAdminBox = this.show;
  },
  watch: {
    show() {
      this.showUpdateSuperAdminBox = this.show;
    },
  },
});

